import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSecurityRulesCriteria,
  fetchSecurityRuleCriteriaById,
  createSecurityRuleCriteria,
  updateSecurityRuleCriteria,
  deleteSecurityRuleCriteria,
} from "@/apis/security/securityRulesCriteriaApi";

const initialState = {
  list: [],
  current: null,
  listLoading: false,
  currentLoading: false,
  saving: false,
  deleting: false,
};

const slice = createSlice({
  name: "securityRulesCriteria",
  initialState,
  reducers: {
    clearCurrentCriteria(state) {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch all
      .addCase(fetchSecurityRulesCriteria.pending, (s) => {
        s.listLoading = true;
      })
      .addCase(fetchSecurityRulesCriteria.fulfilled, (s, a) => {
        s.list = a.payload;
        s.listLoading = false;
      })
      .addCase(fetchSecurityRulesCriteria.rejected, (s) => {
        s.listLoading = false;
      })

      // fetch by id
      .addCase(fetchSecurityRuleCriteriaById.pending, (s) => {
        s.currentLoading = true;
      })
      .addCase(fetchSecurityRuleCriteriaById.fulfilled, (s, a) => {
        s.current = a.payload;
        s.currentLoading = false;
      })
      .addCase(fetchSecurityRuleCriteriaById.rejected, (s) => {
        s.currentLoading = false;
      })

      // create
      .addCase(createSecurityRuleCriteria.pending, (s) => {
        s.saving = true;
      })
      .addCase(createSecurityRuleCriteria.fulfilled, (s, a) => {
        s.list.push(a.payload);
        s.saving = false;
      })
      .addCase(createSecurityRuleCriteria.rejected, (s) => {
        s.saving = false;
      })

      // update
      .addCase(updateSecurityRuleCriteria.pending, (s) => {
        s.saving = true;
      })
      .addCase(updateSecurityRuleCriteria.fulfilled, (s, a) => {
        s.list = s.list.map((c) =>
          c.securityRulesCriteriaID === a.payload.securityRulesCriteriaID
            ? a.payload
            : c
        );
        s.current = a.payload;
        s.saving = false;
      })
      .addCase(updateSecurityRuleCriteria.rejected, (s) => {
        s.saving = false;
      })

      // delete
      .addCase(deleteSecurityRuleCriteria.pending, (s) => {
        s.deleting = true;
      })
      .addCase(deleteSecurityRuleCriteria.fulfilled, (s, a) => {
        s.list = s.list.filter(
          (c) => c.securityRulesCriteriaID !== a.payload
        );
        if (s.current?.securityRulesCriteriaID === a.payload) {
          s.current = null;
        }
        s.deleting = false;
      })
      .addCase(deleteSecurityRuleCriteria.rejected, (s) => {
        s.deleting = false;
      });
  },
});

export const { clearCurrentCriteria } = slice.actions;
export default slice.reducer;
